import React from 'react'
import {UIView, useSrefActive} from '@uirouter/react'
import {Container, ThemeProvider} from '@mdsol/onex-design'
import '@mdsol/onex-design/themeProvider.css'

import LoadingBar from 'react-redux-loading-bar'
import SpeedBump from 'components/common/speedBump/Index'
import ToastsContainer from 'components/common/toast/Index'
import Navbar from 'components/layout/Navbar'
import Tabs from 'components/layout/Tabs'

import {RouterStates} from 'router/states/routerStates.enum'
import {TabType} from 'router/settings'

import './app.scss'

const App = () => {
  const activeClass = 'active'
  const routerRefs = {
    [TabType.home]: useSrefActive(RouterStates.home, {}, activeClass),
    [TabType.databases]: useSrefActive(RouterStates.databases, {}, activeClass),
    [TabType.jobs]: useSrefActive(RouterStates.jobs, {}, activeClass),
    [TabType.jobRequests]: useSrefActive(RouterStates.jobRequests, {}, activeClass),
    [TabType.diagnostics]: useSrefActive(RouterStates.diagnostics, {}, activeClass),
  }

  const activeTab = Object.keys(routerRefs)
    .find(navTab => routerRefs[navTab].className === activeClass) as TabType

  return (
    <ThemeProvider>
      <LoadingBar className='legion-loading-bar' updateTime={300}/>
      <SpeedBump />
      <ToastsContainer />

      <Navbar routerRefs={routerRefs} activeTab={activeTab} />
      <Container id='canvas' fluid>
        <Tabs routerRefs={routerRefs} activeTab={activeTab} />
        <UIView />
      </Container>
    </ThemeProvider>
  )
}

export default App
